// extracted by mini-css-extract-plugin
module.exports = {"container":"statusText_container__1n8jR","statusText":"statusText_statusText__T3h42","textBold":"statusText_textBold__OhJTU"};